export const isTouchDevice = (() => {
  return (navigator.maxTouchPoints || 'ontouchstart' in document.documentElement);
})();

export const fixIosMobileMagnifier = () => {
  if (!isTouchDevice) {
    return;
  }

  // NOTE To test
  //document.body.addEventListener('touchstart', (event) => {
  //  event.preventDefault();
  //}, {
  //  passive: false
  //});
};
